export default "__VITE_ASSET__a732e20a__"